import { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { useFieldContext } from "./FieldContext";

export default function HiddenInput({ id, value }) {
    const context = useFieldContext();
    id = context.idPrefix + id;

    const { register, unregister } = useFormContext();
    useEffect(() => () => unregister(id), []);
    register(id, { value, disabled: context.disabled });

    return null;
}